// extracted by mini-css-extract-plugin
export default {"lessonPageContainer":"LessonPage_lessonPageContainer__6dGsU","lessonContainer":"LessonPage_lessonContainer__83VGW"};